module.exports = __webpack_public_path__ + "static/img/thanks.1b4613f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thanks.svg
// module id = XYWr
// module chunks = 1